import { globalStyle, style } from '@vanilla-extract/css';

import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

const stackReverse = style({});

const mobileHorizontalSqueeze = style({});
const mobileHorizontalScroll = style({});

const alignLeft = style({});
const alignCenter = style({});
const alignRight = style({});
const alignTop = style({});
const alignMiddle = style({});
const alignBottom = style({});

// ⭐️ Overflow is not supported on flex-end, so we need a workaround
// this does not support "snapping" on align right
// Achieved together with the other star
// https://stackoverflow.com/questions/4220327/css-selector-element-with-a-given-child
const stackHorizontal = style({
  '@media': {
    'only screen and (--mobile)': {
      selectors: {
        [`&:has(${alignRight}.${mobileHorizontalScroll})`]: {
          direction: 'rtl',
          overflowX: 'auto',
        },
      },
    },
  },
});

const stackVertical = style({});

const columnElement = style({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 'var(--flex-grow)',
  position: 'relative',
  isolation: 'isolate',
  margin: 'var(--margin)',
  padding: 'var(--padding)',
  borderRadius: 'var(--border-radius)',
  boxShadow: 'var(--box-shadow)',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  '@media': {
    'only screen and (--mobile)': {
      margin: 'var(--margin-mobile)',
      padding: 'var(--padding-mobile)',
      maxWidth: 'var(--mobile-max-width)',
      selectors: {
        [`${rootElement} > &`]: {
          padding: 'var(--padding-root-mobile)',
        },
      },
    },
  },
});

const column = style({
  minHeight: 'var(--min-height)',
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'var(--grid-template-columns)',
  alignItems: 'stretch',
  justifyContent: 'start',
  position: 'relative',
  gap: 'var(--gap)',
  flexGrow: 1,

  '@media': {
    'only screen and (--mobile)': {
      gridTemplateColumns: '1fr', // Single column on mobile
      minHeight: 'unset',
      height: 'auto',
      gap: 'var(--mobile-gap)',
      selectors: {
        [`${stackHorizontal} > &`]: {
          gridTemplateColumns: 'var(--grid-template-columns)',
        },
      },
    },
  },
});

// const column = style({
//   minHeight: 'var(--min-height)',
//   width: '100%',
//   display: 'grid',
//   gridTemplateColumns: 'var(--columns-width)', // Account for gaps
//   alignItems: 'stretch',
//   justifyContent: 'start',
//   position: 'relative',
//   gap: 'var(--gap)',

//   selectors: {
//     [`&${alignLeft}`]: {
//       justifyContent: 'flex-start',
//     },
//     [`&${alignCenter}`]: {
//       justifyContent: 'center',
//     },
//     [`&${alignRight}`]: {
//       justifyContent: 'flex-end',
//     },
//   },

//   '@media': {
//     'only screen and (--mobile)': {
//       minHeight: 'unset',
//       height: 'auto',
//       selectors: {
//         [`${stackHorizontal} > &`]: {
//           flexDirection: 'row',
//           alignItems: 'stretch',
//           gap: 'var(--gap-mobile)',
//         },
//         [`${stackHorizontal}${stackReverse} > &`]: {
//           flexDirection: 'row-reverse',
//         },
//         [`${stackVertical} > &`]: {
//           gap: 'var(--gap-mobile-vertical)',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: 'unset',
//         },
//         [`${stackVertical}${stackReverse} > &`]: {
//           flexDirection: 'column-reverse',
//         },
//         [`${stackHorizontal} >&${alignCenter}:not(${mobileHorizontalSqueeze}),
//           ${stackHorizontal} >&${alignLeft}:not(${mobileHorizontalSqueeze}),
//           ${stackHorizontal} >&${mobileHorizontalScroll}`]: {
//           scrollSnapType: 'x mandatory',
//           overflowX: 'auto',
//         },

//         // ⭐️ Overflow is not supported on flex-end, so we need a workaround
//         // this does not support "snapping" on align right
//         // Achieved together with the other star
//         // https://stackoverflow.com/questions/4220327/css-selector-element-with-a-given-child
//         [`${stackHorizontal} >&${alignRight}:not(${mobileHorizontalSqueeze})`]: {
//           justifyContent: 'flex-start',
//           flexDirection: 'row-reverse',
//           width: 'fit-content',
//         },
//       },
//     },
//   },
// });

const background = style({
  position: 'absolute',
  inset: 0,
  userSelect: 'none',
  borderRadius: 'var(--border-radius)',
  overflow: 'clip',
});

globalStyle(`${background} img`, {
  pointerEvents: 'none',
});

globalStyle(`${background} ~ *`, {
  zIndex: 1,
});

export default {
  columnElement,
  stackVertical,
  stackReverse,
  stackHorizontal,
  mobileHorizontalSqueeze,
  mobileHorizontalScroll,
  background,
  column,
  alignLeft,
  alignCenter,
  alignRight,
  alignTop,
  alignMiddle,
  alignBottom,
};
